// Angular
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import { Store, select } from '@ngrx/store';
import {Observable, Subject, Subscription} from 'rxjs';
// Layout
import { OffcanvasOptions } from '../../../../core/_base/layout';
import { AppState } from '../../../../core/reducers';
import { currentUser, Logout, User } from '../../../../core/auth';
import { AngularFireAuth } from '@angular/fire/auth';
import {filter, take, takeUntil} from 'rxjs/operators';
import {NavigationEnd, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {AngularFirestore} from '@angular/fire/firestore';
import {UserStatusService} from '../../../../services/user-status/user-status.service';
import {AngularFireStorage} from '@angular/fire/storage';
import {FirebaseService} from '../../../../services/firebase/firebase.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {IUser} from '../../../../core/interfaces/user';
import {currentUserDetails} from '../../../../core/auth/_selectors/auth.selectors';
import {CurrentUserService} from '../../../../services/current-user/current-user.service';
import {SubscriptionsService} from '../../../../services/subscriptions/subscriptions.service';
import {TRAINING_BUDGES} from "../../../../core/consts/training-badges";
import {TenantService} from "../../../../core/tenant/tenant.service";

@Component({
  selector: 'kt-quick-user-panel',
  templateUrl: './quick-user-panel.component.html',
  styleUrls: ['./quick-user-panel.component.scss']
})
export class QuickUserPanelComponent implements OnInit {
  details: any;
  today: number = Date.now();
  currentRouteUrl = '';
  user$: Observable<any>;
  currentUser: IUser;
  preferableLanguage = 'en';
  // Public properties
  offcanvasOptions: OffcanvasOptions = {
    overlay: true,
    baseClass: 'offcanvas',
    placement: 'right',
    closeBy: 'kt_quick_user_close',
    toggleBy: 'kt_quick_user_toggle'
  };

  logoutSubscription: Subscription;
  devicesList = [];
  userTotalTrainings = 0;
  trainingBadges = TRAINING_BUDGES;
  badgesArray = [];
  currentUserBadge = {
    name: 'BADGES_NAMES.NONE',
    path: ''
  };

  constructor(
    private store: Store<AppState>,
    private afa: AngularFireAuth,
    private translate: TranslateService,
    private afs: AngularFirestore,
    private cdr: ChangeDetectorRef,
    private userStatus: UserStatusService,
    private firebaseAuth: AngularFireAuth,
    private router: Router,
    private afstorage: AngularFireStorage,
    private firebase: FirebaseService,
    private firebaseUser: CurrentUserService,
    private subscriptions: SubscriptionsService,
    public tenant: TenantService
  ) {

  }

  /**
   * On init
   */
  ngOnInit(): void {
    this.user$ = this.firebaseUser.getCurrentUser();
    this.user$.pipe(take(1)).subscribe((user) => {
      this.currentUser = user;
      this.getTrainingData();
      if (user.devices) {
        user.devices.forEach((device) => {
          this.firebase.getDeviceByName(device).pipe(take(1)).subscribe((cloudDevice:any) => {
            if (cloudDevice) {
              const includes = this.devicesList.find(el => el.deviceName === cloudDevice.deviceName);
              if (!includes) {
                this.devicesList.push(cloudDevice);
                this.cdr.markForCheck();
              }
            }
          });
        });
      }
    });
  }

  getTrainingData() {
      this.firebase.getStatisticRecords(this.currentUser.id).pipe(take(1)).subscribe((records:any) => {
        records.forEach((record) => {
          if (record.seconds instanceof Array) {
            record.seconds = 0;
          }
          record.day = new Date(0).setUTCSeconds(record.day.seconds);
          record.day = new Date(record.day);
        });
        this.userTotalTrainings = records.length;
        this.getCurrentBadge();
      });
  }
  getCurrentBadge() {
    this.badgesArray = [];
    this.trainingBadges.forEach((badge) => {
      if (this.userTotalTrainings >= badge.sessionsNeeded) {
        badge.reached = true;
        this.badgesArray.push(badge);
      } else {
        badge.reached = false;
        this.badgesArray.push(badge);
      }
    });
    this.badgesArray.forEach((item) => {
      if (item.reached) {
        const badges = [];
        badges.push(item);
        this.currentUserBadge = badges.slice(-1)[0];
      }
    });
  }

  logout() {
    this.afa.signOut().then(() => {
      this.store.dispatch(new Logout());
      this.subscriptions.subscriptionsError.next(false);
      if (this.logoutSubscription) {
        this.logoutSubscription.unsubscribe();
      }
    }).catch(error => {
      console.log(error)
    })
    // this.logoutSubscription =  this.userStatus.setUserOffline().subscribe((user) => {
    //   if (user) {
    //       this.afa.signOut().then(() => {
    //         this.store.dispatch(new Logout());
    //         this.subscriptions.logout();
    //         this.subscriptions.subscriptionsError.next(false);
    //         if (this.logoutSubscription) {
    //           this.logoutSubscription.unsubscribe();
    //         }
    //       }).catch(error => {
    //         console.log(error)
    //       })
    //   }
    // });
    setTimeout(() => {
      this.afa.signOut().then(() => {
        this.store.dispatch(new Logout());
      }).catch(error => {
        console.log(error)
      })
    }, 1000)
  }

  changeProfileImg(event, element) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.setImageDownloadUrl(reader.result).then((url) => {
        const user = {
          photoURL: url
        }
        this.firebase.updateUser(this.currentUser.uid, user);
        element.value = '';
        this.cdr.markForCheck();
      });
      this.cdr.markForCheck()
    };
  }

  setImageDownloadUrl(baseImage) {
    const ref = this.afstorage.storage.ref();
    const imgRef = ref.child(`usersPhoto/${this.currentUser.uid}/${Date.now()}`);
    return new Promise((resolve, reject) => {
      imgRef.putString(baseImage, 'data_url').then(() => {
        imgRef.getDownloadURL().then((imageUrl) => {
          resolve(imageUrl);
        })
      })
    })
  }
}
